<template>
  <b-container>
    <b-row>
      <b-col>
        <div class="chip_class" v-if="filterItemsArray && filterItemsArray.length > 0">
          <div class="">
            <div class="filter_chip" v-if="filterItemsArray[0]['Date'] !== ''">
              <span>Date: {{ filterItemsArray[0]["Date"] }}</span>
              <span @click="removeChip('Date')"><i class="pi pi-times"></i>
              </span>
            </div>
            <div class="filter_chip" v-if="filterItemsArray[0]['Code'] !== ''">
              <span>Code: {{ filterItemsArray[0]["Code"] }}</span>
              <span @click="removeChip('Code')"><i class="pi pi-times"></i>
              </span>
            </div>
          </div>
          <div class="">
            <button class="btn resetallfilter me-2 rounded-pill float-end" @click="ResetFilter">
              Clear all
            </button>
          </div>
        </div>
        <div class="form-white-bg" v-if="windowWidth > 545">
          <b-row>
            <b-col :lg="visible ? '3' : '0'" md="3">
              <b-collapse id="collapse-1" class="mt-2" v-model="visible">
                <FilterForm :sidedisplay="true" @FilterValues="Filter" @ResetValues="ResetFilter"
                  :ClearDateFilter="SearchValue" v-if="FilterLoading">
                  <template v-slot:filterslot>
                    <itemIssueGrnReturnFilters @updatedcode="Emitcode" :removechiptype="removechipvalue"
                      :itemsList="items" />
                  </template>
                </FilterForm>
              </b-collapse>
            </b-col>
            <b-col :lg="items.length !== 0 && visible ? '9' : '12'">
              <SkeletonTableLoader :columns="headers" :loading="loading" />
              <div v-if="!loading">
                <MasterEmpty :createline="QueryStringValue.StroeId || IsAddButton" v-if="
                  items.length === 0 &&
                  !SearchValue.inputValue &&
                  !SearchValue.fromDate &&
                  !SearchValue.toDate &&
                  !DetailsId.PIId &&
                  !DetailsId.PRId
                " eheader="GRN Return" econtent="GRN Return" eimg="/src/assets/Img/icons/itemmaster.svg"
                  @createNew="IsCreate()" />
                <Tableview v-if="
                  items.length !== 0 ||
                  SearchValue.inputValue ||
                  SearchValue.fromDate ||
                  SearchValue.toDate
                " :value="items" :paginator="false" class="p-datatable-gridlines" :rows="10" dataKey="id"
                  :rowHover="true" filterDisplay="menu" :loading="loading1" responsiveLayout="scroll" :columns="headers"
                  :globalFilterFields="globalFilterFields" :filters="filters" :totalRecords="rowsCount" :state="state"
                  @ShowRows="ShowRows" :searchbox="false" :searchbox1="true" @search="SearchBox" :exceldownload="true"
                  :filterbtn="true" :statusFilterBtn="true" @row-click="RowClick" :showColumnFilters="false">
                  <template v-slot:statusFilterBtn>
                    <div class="filterBtnStatus d-flex align-items-center">
                      <div class="filter_chip1" :class="{ 'selected-chip': item.id === selectedStatus }"
                        v-for="item in filterStatus" :key="item.id" @click="selectStatus(item.id, item.name)">
                        <p>
                          <span>{{ item.name }}</span>
                        </p>
                      </div>
                    </div>
                  </template>
                  <template v-slot:exceldownload>
                    <ExportOption @ExportExcel="ExportExcel" @ExportPDF="ExportPDF" :ExportList="ExportList"
                      :PageName="PageName" :ExportOption="ExportOption" class="ms-2" :HideAndShow="true" />
                  </template>
                  <template v-slot:filter>
                    <i class="pi pi-filter tablefilter" :class="visible ? null : 'collapsed'"
                      :aria-expanded="visible ? 'true' : 'false'" aria-controls="collapse-4"
                      @click="visible = !visible"></i>
                  </template>
                  <template v-slot:Add v-if="!QueryStringValue.StroeId || IsAddButton">
                    <span class="add">
                      <AddButton @click="IsCreate()" :btnname="$t('btn.plusaddnew')"></AddButton>
                    </span>
                  </template>
                  <template v-slot:action="{ data }">
                    <span>
                      <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
                        @click="toggle($event, data)" />
                    </span>
                  </template>
                  <template v-slot:Status="{ data }">
                    <span>
                      <RedStatus name="Draft" v-if="data.IsDraft == '1'" />
                      <OrangeStatus name="Pending" v-if="
                        data.GRNReturnStatus == '0' && data.IsDraft != '1'
                      " />
                      <BlueStatus name="Partial" v-if="
                        data.GRNReturnStatus == '1' && data.IsDraft != '1'
                      " />
                      <GreenStatus name="Completed" v-if="
                        data.GRNReturnStatus == '2' && data.IsDraft != '1'
                      " />
                    </span>
                  </template>
                </Tableview>
              </div>
            </b-col>
          </b-row>
        </div>
        <div v-if="windowWidth <= 545">
          <MobileLoader v-if="loading" v-for="item in 5" />
          <div v-if="!loading">
            <MasterEmpty :createline="QueryStringValue.StroeId" v-if="
              items.length === 0 &&
              !SearchValue.inputValue &&
              !SearchValue.fromDate &&
              !SearchValue.toDate &&
              !DetailsId.PIId &&
              !DetailsId.PRId
            " eheader="GRN Return" econtent="GRN Return" eimg="/src/assets/Img/icons/itemmaster.svg"
              @createNew="IsCreate()" />
            <MobileViewCardHeader :totalRecords="rowsCount" :state="state" @IsAdd="IsCreate">
              <template v-slot:mobilecard>
                <div class="mobile-card" v-for="item in items">
                  <div class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center gap-1">
                      <p class="light-name">{{ item["DocNo"] }}</p>
                      <p class="light-name1">/ {{ item["DocDate"] }}</p>
                    </div>
                    <i class="pi pi-ellipsis-v" @click.stop="toggle($event, item)"></i>
                  </div>
                  <p class="name">{{ item["FromStoreName"] }}</p>
                  <div class="d-flex align-items-center gap-2">
                    <p class="light-name">Item count :</p>
                    <p class="small-name">{{ item["ItemCount"] }}</p>
                  </div>
                  <div class="d-flex align-items-center gap-2">
                    <p class="light-name">Item value :</p>
                    <p class="small-name">{{ item["ItemCount"] }}</p>
                  </div>
                </div>
              </template>
            </MobileViewCardHeader>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>

  <!-- Commenly Used Components -->
  <Menu ref="menu" id="overlay_menu" :model="itemList" :popup="true" />
  <EditConfirmation :Editmodel="popup.Editmodel" @yes="IsEdit(dataEdit)" @no="popup.Editmodel = false"
    :content="$t('confirmation.editcontent')" />
  <DeleteConfirmationVue :DeleteModel="popup.Deletemodel" @yes="IsDelete(dataEdit)" @no="popup.Deletemodel = false" />
  <DeletedSuccessfully :visible="popup.deletepop" @ok="closetrigger()" />
  <Toast />
  <CrystalReportPrintPopUp :ShowAndHide="CrystalReportPopup" :ParameterValues="ParameterValues" :PrintType="PrintType"
    @closepopup="hidepopup" />
  <!-- Commenly Used Components -->
</template>
<script lang="ts">
import {
  defineComponent,
  ref,
  h,
  onMounted,
  watch,
  reactive,
  onUnmounted,
} from "vue";
import Headerlayout from "../../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../../components/FormComponents/BacktoMaster.vue";

// import PaymentCreation from '../../Masters/Supplier/PaymentTerms/PaymentTermsCreation.vue'
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";

import Table from "../../../../../../components/FormComponents/Table.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Tableview from "../../../../../../components/FormComponents/Table.vue";
import { useI18n } from "vue-i18n";
import commonService from "../../../../Service/StockOutService";
import Service from "../../../../Service/WithoutStockAffectService";

import DeleteConfirmationVue from "../../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../../components/FormComponents/DeletedSuccessfully.vue";
import EditConfirmation from "../../../../../../components/FormComponents/EditConfirmation.vue";
// import GrnDetails from "../../../../../pages/Transaction/stockin/grn/GrnDetails.vue";
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import MasterEmpty from "../../../../../../components/Masters/MasterEmpty.vue";
import { useToast } from "primevue/usetoast";
import { checkPermission } from "../../../../../../modules/Inventory/Service/AccessControl";
import MastersService from "../../../../Service/MastersService";
import SkeletonTableLoader from "../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from "../../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import itemIssueGrnReturnFilters from "../../../../../../modules/Inventory/components/Filters/itemIssueGrnReturnFilters.vue";
import moment from "moment";
import FilterForm from "../../../../../../components/FormComponents/FilterForm.vue";
import CrystalReportPrintPopUp from "../../../../../../modules/Inventory/components/Print/CrystalReportPrint.vue";
import ExportOption from "../../../../../../components/FormComponents/Export.vue";
import debounce from "lodash/debounce";

export default defineComponent({
  components: {
    BacktoPage,
    Headerlayout,

    Table,
    Tableview,
    DeleteConfirmationVue,
    DeletedSuccessfully,
    EditConfirmation,
    Loader,
    MasterEmpty,
    SkeletonTableLoader,
    MobileViewCardHeader,
    MobileLoader,
    itemIssueGrnReturnFilters,
    FilterForm,
    CrystalReportPrintPopUp,
    ExportOption,
  },
  props: {
    propsParams: {
      type: Object,
    },
    FunctionRights: {
      type: Object,
    },
    IsAddButton: {
      type: Boolean,
      default: true,
    },
    DetailsId: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const ParamValues = ref({
      requestId: "",
      StoreId: 0,
      status: 0,
      Type: "",
      BranchId: 0,
      Id: 0,
      DocNo: "",
      StockTransId: 0,
      SupplierId: 0,
    });
    let ObjOperationId = ref({
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
    });
    const rowsCount = ref(0);
    const { t } = useI18n();
    const routes = useRoute();
    const toast = useToast();

    let StoreId = routes.query.Id;
    let status = routes.query.status ?? "";
    let Type = routes.query.Type;
    let BranchId = Number(routes.query.BranchId ?? 0);

    ParamValues.value.StoreId = Number(StoreId);
    ParamValues.value.status = Number(status);
    ParamValues.value.Type = String(Type);
    ParamValues.value.BranchId = Number(BranchId);

    let visible = ref(false);

    const CrystalReportPopup = ref(false);
    const ParameterValues = ref({
      Id: 0,
      BranchId: 0,
      HospitalId: 0,
    });

    const PrintType = ref({
      Type: "T",
      FormId: 5,
      HeaderTitle: "GRN Return",
      ModuleId: 3,
    });

    let ExportList = ref([]);
    let PageName = ref("GRN Return");
    let ExportOption = ref("");

    let btnEditHide = ref(true);
    let btnDeleteHide = ref(false);

    let objectdata = ref({});
    const dataEdit = ref();
    const menu = ref();
    const router = useRouter();
    const generic = ref();
    let items = ref([]);
    let loading1 = ref(false);
    let loading = ref(false);

    let QueryStringValue: any = routes.query;
    let StoreBrMapId = routes.query.storebranchmapid ?? 0;

    // let DetailsId = ref({
    //   PIId: QueryStringValue["PIId"] ?? 0,
    //   PRId: QueryStringValue["PRId"] ?? 0,
    // });

    let DetailsId = ref({
      PIId: 0,
      PRId: 0,
    });

    watch(
      () => [props.DetailsId],
      ([newQueryValue]) => {
        debugger;
        if (newQueryValue.PIId) {
          DetailsId.value.PIId = newQueryValue.PIId;
        } else if (newQueryValue.PRId) {
          DetailsId.value.PRId = newQueryValue.PRId;
        }
      },
      { immediate: true }
    );

    // if (DetailsId.value.PIId != 0 || DetailsId.value.PRId != 0) {
    //   btnEditHide.value = true;
    //   btnDeleteHide.value = true;
    // } else {
    //   btnEditHide.value = false;
    //   btnDeleteHide.value = false;
    // }

    let dataValue1 = {
      Id: 0,
      status: 0,
      Type: "",
      Type1: "",
    };

    let Rights: any = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });
    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }
    async function FunctionRights() {
      debugger;
      const response = await MastersService.CheckMenuRights(
        122,
        rolesData.RoleId
      );
      console.log(response["result"]);

      for (let i = 0; i < response["result"].length; i++) {
        const operation = response["result"][i];
        if (operation.OperationName === "Create") {
          ObjOperationId.value.CreateId = operation.OperationID;
          Rights.value.Create = operation.IsActive;
        } else if (operation.OperationName === "Update") {
          ObjOperationId.value.UpdateId = operation.OperationID;
          Rights.value.Update = operation.IsActive;
        } else if (operation.OperationName === "Read") {
          ObjOperationId.value.ReadId = operation.OperationID;
          Rights.value.Read = operation.IsActive;
        } else if (operation.OperationName === "Delete") {
          ObjOperationId.value.DeleteId = operation.OperationID;
          Rights.value.Delete = operation.IsActive;
        }
      }
    }

    const windowWidth = ref(window.innerWidth);
    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };

    const filterStatus = [
      { id: 4, name: "All" },
      { id: 0, name: "Pending" },
      { id: 1, name: " Partially" },
      { id: 2, name: "Completed" },
    ];

    const selectedStatus = ref(4);
    let buttonFilter = ref({
      Id: 0,
      Name: "",
    });

    let StatusFilter = ref({
      StatusFrom: "GRNReturn",
      Status: true,
      AprrovalStatus: true,
    });

    let SelectedFilterId: any = ref(4);

    const selectStatus = (id, name) => {
      debugger;
      selectedStatus.value = id;
      SelectedFilterId.value = id;
      IsShow();
    };

    // const StoreId = routes.query.StoreId
    onMounted(() => {
      window.addEventListener("resize", handleResize);
      if (windowWidth.value < 545) {
        state.pageSize = 5;
      } else {
        state.pageSize = 10;
      }

      FunctionRights();

      if (DetailsId.value.PIId != 0 || DetailsId.value.PRId != 0) {
        GRNReturnDetails();
      } else {
        IsShow();
      }
    });

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });

    watch(
      () => windowWidth.value,
      (newVal) => {
        if (newVal < 545) {
          state.pageSize = 5;
        } else {
          state.pageSize = 10;
        }
      }
    );

    const popup = ref({
      Deletemodel: false,
      deletepop: false,
      Editmodel: false,
    });

    const itemList = ref([
      {
        items: [
          {
            label: "Edit",
            icon: "editicon pi pi-pencil",
            visible: btnEditHide,
            command: async () => {
              IsConfirmEdit(objectdata);
            },
          },
          {
            label: "Delete",
            icon: "deleteicon pi pi-trash",
            visible: btnDeleteHide,
            command: async () => {
              IsConfirmDel(objectdata);
            },
          },
          {
            label: "Print",
            icon: "editicon pi pi-print",
            visible: true,
            command: async () => {
              Print(objectdata);
            },
          },
        ],
      },
    ]);

    function datapass(data) {
      debugger;
      console.log(data["DocNo"]);
      ParamValues.value.requestId = data["DocNo"];
      router.push({
        path: "/Issue",

        query: {
          data: JSON.stringify(ParamValues.value),
          param: "IndirectIssue",
        },
      });
    }

    const toggle = (event, data) => {
      objectdata = data;
      console.log(event);
      menu.value.toggle(event);
    };

    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      DocNo: { value: null, matchMode: FilterMatchMode.IN, options: items },
      DocDate: { value: null, matchMode: FilterMatchMode.IN, options: items },
      SupplierName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
    };

    const headers = [
      {
        header: t("storetabdetails.grnreturn.sno"),
        field: "RowNumber",
        class: "filterdisplaynone",
      },
      {
        header: t("storetabdetails.po.Status"),
        field: "POStatusName",
        fieldDisplay: "false",
        slot: "Status",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "mediumwidth",
        // bodyclass: "text_overflow2",
      },
      {
        header: t("storetabdetails.grnreturn.BranchName"),
        field: "BranchName",
        class: "filterdisplaynone",
      },
      {
        header: t("storetabdetails.grnreturn.Code"),
        field: "DocNo",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grnreturn.Date"),
        field: "DocDateHR",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grnreturn.InvoiceNo"),
        field: "InvoiceNo",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grnreturn.GRNCode"),
        field: "RefNo",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grnreturn.SupplierName"),
        field: "SupplierName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },

      {
        header: t("storetabdetails.grnreturn.ItemCount"),
        field: "ItemCount",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grnreturn.Value"),
        field: "Amount",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grnreturn.ReturnType"),
        field: "ReturnTypeName",
        // bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grnreturn.CreatedBy"),
        field: "CreatedByName",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grnreturn.CreatedAt"),
        field: "CreatedAtHR",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grnreturn.ModifiedBy"),
        field: "ModifiedByName",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grnreturn.ModifiedAt"),
        field: "ModifiedAtHR",
        class: "smallwidth",
      },
      {
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        // hide: ColumnVisible.value,
        class: "filterdisplaynone last-column-position",
        fieldDisplay: "false",
      },
    ];

    const globalFilterFields = ref(headers.map((col) => col.field));

    const IsCreate = () => {
      debugger;
      let permissionResult: any = checkPermission(Rights, "Add");

      if (permissionResult.hasPermission) {
        router.push({
          name: "GRNReturn",
          query: {
            param: "GRNReturn",
            StoreId: ParamValues.value.StoreId,
            status: ParamValues.value.status,
            Type: ParamValues.value.Type,
            refNo: "",
            Id: 0,
            SupplierId: 0,
            OperationId: ObjOperationId.value.CreateId,
            EntityId: 3026,
            storebranchmapid: StoreBrMapId,
            BranchId: ParamValues.value.BranchId,
            IsGRNDetails: 0,
          },
        });
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    };

    function IsConfirmEdit(data) {
      debugger;
      let permissionResult: any = checkPermission(Rights, "Edit");

      if (permissionResult.hasPermission) {
        dataEdit.value = data;
        popup.value.Editmodel = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    function IsConfirmDel(data) {
      debugger;
      let permissionResult: any = checkPermission(Rights, "Delete");

      if (permissionResult.hasPermission) {
        dataEdit.value = data;
        popup.value.Editmodel = false;
        popup.value.Deletemodel = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    function IsEdit(data) {
      debugger;
      router.push({
        name: "GRNReturn",
        query: {
          param: "GRNReturn",
          StoreId: ParamValues.value.StoreId,
          status: ParamValues.value.status,
          Type: ParamValues.value.Type,
          refNo: data.RefNo,
          Id: data.Id,
          SupplierId: 0,
          OperationId: ObjOperationId.value.UpdateId,
          EntityId: 3026,
          storebranchmapid: StoreBrMapId,
          BranchId: ParamValues.value.BranchId,
          IsGRNDetails: 0,
        },
      });
    }

    const state = reactive({
      pagedItems: [], // contains a subset of rows for the current page
      currentPage: 1, // current page number
      pageSize: 10, // number of rows per page
      totalRows: 0, // total number of rows in the database
    });

    watch(props, (newValue) => {
      debugger;
      Object.assign(dataValue1, newValue.propsParams);
      if (dataValue1.Id) {
        items.value = [];
        ParamValues.value.StoreId = Number(dataValue1.Id);
        ParamValues.value.status = dataValue1.status;
        let Type: any = dataValue1.Type;
        let Type1: any = dataValue1.Type1;

        if (DetailsId.value.PIId != 0 || DetailsId.value.PRId != 0) {
          GRNReturnDetails();
        } else {
          IsShow();
        }
      }
    });

    function ShowRows(value) {
      debugger;
      if (value != 0 && value != null && value != undefined) {
        state.pageSize = value;
        IsShow();
      }
    }

    watch(
      [() => state.currentPage, () => state.pageSize],
      async ([pageNum, pageSize]) => {
        debugger;
        await IsShow();
      }
    );
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData: any;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }
    //Get data for TableView
    async function IsShow() {
      debugger;
      try {
        loading.value =
          SearchValue.value.inputValue ||
            SearchValue.value.fromDate ||
            SearchValue.value.toDate
            ? false
            : true;

        const pageNum = SelectedFilterId.value == 4 ? state.currentPage : 0;
        const pageSize = SelectedFilterId.value == 4 ? state.pageSize : 0;
        const columnName = Type == "StoreId" ? "StoreId" : "SupplierId";
        const columnValue = StoreId;
        const columnName1 = "";
        const columnValue1 = "";
        const columnName2 = filterItems.value.Code ? "DocNo" : "";
        const columnValue2 = filterItems.value.Code
          ? filterItems.value.Code
          : "";
        const columnName3 = "";
        const columnValue3 = "";

        let Flag = 1,
          searchOption = "";

        if (SearchValue.value.inputValue != "") {
          Flag = 2;
          searchOption = SearchValue.value.inputValue;
        }
        let Condition =
          "sm.HospitalId=" +
          usersData.OrganizationId +
          "  and (COALESCE('" +
          usersData.BranchId +
          "', '0') = '0' OR sm.BranchId IN (SELECT * FROM dbo.Split('" +
          usersData.BranchId +
          "', ',')))";
        let response = await commonService.listStockOutMasterTM(
          SearchValue.value.fromDate ? SearchValue.value.fromDate : "",
          SearchValue.value.toDate ? SearchValue.value.toDate : "",
          pageSize,
          pageNum,
          12,
          columnName,
          columnValue,
          columnName1,
          columnValue1,
          columnName2,
          columnValue2,
          columnName3,
          columnValue3,
          "",
          "",
          Flag,
          searchOption,
          Condition
        );

        if (SelectedFilterId.value == 4) {
          items.value = response["result"]
            .filter((item) => item["StoreBrMapId"] == StoreBrMapId)
            .map((item) => {
              item.Amount = Number(item.Amount).toFixed(2);
              return item;
            });
        } else {
          items.value = response["result"]
            .filter((item) => item["StoreBrMapId"] == StoreBrMapId)
            .filter((item) => item["GRNReturnStatus"] == SelectedFilterId.value)
            .map((item) => {
              item.Amount = Number(item.Amount).toFixed(2);
              return item;
            });
        }

        rowsCount.value =
          response["result"].length > 0
            ? response["result"][0]["rowscount"]
            : 0;

        console.log(items.value);
        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    }

    function ExportExcel() {
      debugger;
      ExportOption.value = "Excel";
      IsShowExport();
    }

    function ExportPDF() {
      debugger;
      ExportOption.value = "PDF";
      IsShowExport();
    }

    async function IsShowExport() {
      debugger;
      try {
        loading.value = false;

        const pageNum = state.currentPage;
        const pageSize = 0;

        const columnName = Type == "StoreId" ? "StoreId" : "SupplierId";
        const columnValue = StoreId;
        const columnName1 = "";
        const columnValue1 = "";
        const columnName2 = filterItems.value.Code ? "DocNo" : "";
        const columnValue2 = filterItems.value.Code
          ? filterItems.value.Code
          : "";
        const columnName3 = "";
        const columnValue3 = "";

        let Flag = 1,
          searchOption = "";

        if (SearchValue.value.inputValue != "") {
          Flag = 2;
          searchOption = SearchValue.value.inputValue;
        }
        let Condition =
          "sm.HospitalId=" +
          usersData.OrganizationId +
          "  and (COALESCE('" +
          usersData.BranchId +
          "', '0') = '0' OR sm.BranchId IN (SELECT * FROM dbo.Split('" +
          usersData.BranchId +
          "', ',')))";

        let response = await commonService.listStockOutMasterTM(
          SearchValue.value.fromDate ? SearchValue.value.fromDate : "",
          SearchValue.value.toDate ? SearchValue.value.toDate : "",
          pageSize,
          pageNum,
          12,
          columnName,
          columnValue,
          columnName1,
          columnValue1,
          columnName2,
          columnValue2,
          columnName3,
          columnValue3,
          "",
          "",
          Flag,
          searchOption,
          Condition
        );

        rowsCount.value =
          response["result"].length > 0
            ? response["result"][0]["rowscount"]
            : 0;

        ExportList.value = response["result"].map((item) => {
          const filteredItem = {};

          headers.forEach(({ header, field }) => {
            filteredItem[header] = item[field];
          });

          return filteredItem;
        });

        console.log(items.value);
        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    }

    let ObjVal4 = reactive({
      arraylenght: 0,
    });

    function update() {
      debugger;
      emit("update:modelValue", ObjVal4);
    }

    async function GRNReturnDetails() {
      debugger;
      try {
        let response = await commonService.GetListByPIId(
          // ParamValues.value.StoreId
          DetailsId.value.PIId || DetailsId.value.PRId
        );
        items.value = response["result"];
        ObjVal4.arraylenght = response["result"].length;
        update();
        if (response["result"].length > 0) {
          rowsCount.value = response["result"].length;
        }
        console.log(items.value);
      } catch (error) {
        console.log(error);
      }
    }

    //Edit Click function
    // async function EditData(id) {
    //     debugger;
    //     router.push({
    //         path: '/SupplierMasterCreation',
    //         query: { id: id }
    //     })
    // }

    //Delete Values in Table

    const IsDelete = async (data) => {
      try {
        // alert(JSON.stringify(data.Id))
        const response = await commonService.DeleteStockOutTM(data.Id);
        let message = response["ErrorInfo"].ErrorCode;
        if (message == null) {
          popup.value.Deletemodel = false;
          popup.value.deletepop = true;
          IsShow();
        }
      } catch (error) {
        console.log(error);
      }
    };

    // Popup-Close
    function closetrigger() {
      popup.value.deletepop = false;
    }

    function Print(ObjData) {
      debugger;
      CrystalReportPopup.value = true;

      ParameterValues.value.Id = ObjData.Id;
      ParameterValues.value.BranchId = ObjData.BranchId;
      ParameterValues.value.HospitalId = ObjData.HospitalId;
    }

    const hidepopup = () => {
      CrystalReportPopup.value = false;
    };

    let FilterLoading = ref(true);
    const filtervisible = ref(false);
    let filterItemsArray: any = ref([]);
    let filterItems = ref({
      Date: "",
      Code: "",
      StatusIds: "",
    });

    let emitedfilterItems = ref({
      Code: "",
    });
    let SearchValue = ref({
      inputValue: "",
      fromDate: "",
      toDate: "",
    });
    const removechipvalue = ref(0);
    const Emitcode = (data) => {
      emitedfilterItems.value.Code = data;
    };

    function Filter(values) {
      debugger;
      if (
        values.fromdate !== undefined &&
        values.fromdate !== "" &&
        values.todate !== undefined &&
        values.todate !== ""
      ) {
        filterItems.value.Date =
          moment(values.fromdate).format("DD MMM YY") +
          " To " +
          moment(values.todate).format("DD MMM YY");
      } else if (values.fromdate !== undefined && values.fromdate !== "") {
        filterItems.value.Date = moment(values.fromdate).format("DD MMM YY");
      } else if (values.todate !== undefined && values.todate !== "") {
        filterItems.value.Date = moment(values.todate).format("DD MMM YY");
      } else {
        filterItems.value.Date = "";
      }

      filterItems.value.Code = emitedfilterItems.value.Code;

      filterItemsArray.value = [];

      filterItemsArray.value.push(filterItems.value);

      SearchDate(values.fromdate, values.todate);
      removechipvalue.value = 0;
      filtervisible.value = false;
    }

    function ResetFilter(values) {
      debugger;
      SearchValue.value.fromDate = "";
      SearchValue.value.toDate = "";
      removechipvalue.value = 3;
      filterItems.value.Code = "";
      state.pagedItems = [];
      state.currentPage = 1;
      state.pageSize = 10;
      state.totalRows = 0;
      filterItemsArray.value = [];
      filterItems.value.Date = "";
      IsShow();
    }

    // Debounced search for server-side filtering
    function SearchBox(value) {
      if (value === "" || value.length >= 3) {
        debouncedSearch(value);
      }
    }

    const debouncedSearch = debounce((input) => {
      SearchValue.value.inputValue = value;
      state.pagedItems = [];
      state.currentPage = 1;
      state.pageSize = 10;
      state.totalRows = 0;
      IsShow();
    }, 300);

    function RowClick(event: any) {
      debugger;
      router.push({
        name: "GRNReturn",
        query: {
          param: "GRNReturn",
          StoreId: ParamValues.value.StoreId,
          status: ParamValues.value.Type,
          Type: ParamValues.value.status,
          refNo: event.data.RefNo,
          RefId: ParamValues.value.StockTransId,
          SupplierId: ParamValues.value.SupplierId,
          OperationId: 3026001,
          EntityId: 3026,
          Id: event.data.Id,
          storebranchmapid: StoreBrMapId,
          BranchId: ParamValues.value.BranchId,
          IsGRNDetails: 1,
        },
      });
    }
    // ParamValues.value.DocNo
    function SearchDate(fromDate, ToDate) {
      debugger;
      SearchValue.value.fromDate = fromDate
        ? moment(fromDate).format("YYYY-MM-DD")
        : "";
      SearchValue.value.toDate = ToDate
        ? moment(ToDate).format("YYYY-MM-DD")
        : "";

      state.pagedItems = [];
      state.currentPage = 1;
      state.pageSize = 10;
      state.totalRows = 0;

      IsShow();
    }

    const removeChip = (data) => {
      debugger;
      if (data == "Date") {
        SearchValue.value.fromDate = "";
        SearchValue.value.toDate = "";
      } else if (data == "Code") {
        removechipvalue.value = 1;
      }
      filterItems.value[data] = ""; // Clear the value in the filterItems object
      IsShow();
    };

    return {
      itemList,
      ParamValues,
      datapass,
      headers,
      items,
      IsShow,
      IsDelete,
      generic,
      loading1,
      loading,
      globalFilterFields,
      filters,
      IsCreate,
      IsEdit,
      menu,
      toggle,
      popup,
      dataEdit,
      IsConfirmEdit,
      IsConfirmDel,
      closetrigger,
      state,
      rowsCount,
      QueryStringValue,
      Filter,
      ResetFilter,
      filterItemsArray,
      filtervisible,
      SearchValue,
      FilterLoading,
      Emitcode,
      removeChip,
      removechipvalue,
      SearchBox,
      CrystalReportPopup,
      ParameterValues,
      PrintType,
      hidepopup,
      ExportOption,
      ExportList,
      PageName,
      ExportExcel,
      ExportPDF,
      ShowRows,
      windowWidth,
      visible,
      DetailsId,
      filterStatus,
      selectedStatus,
      selectStatus,
      RowClick,
    };
  },
});
</script>
